// Our Solutions Component

import React, { useState } from "react"
import MenuCard from "../menu-card.js/menuCard"
// import { ConnectWithUsBtns } from "../home/home"
// import { useAppContext } from "../../context/appContext"
// import gtag from "ga-gtag"
// import { onContactUsBtnClick } from "../../commonFunctions/commonFunctions"

const SolutionsMenu = ({ data }) => {
  // const { setShowChatWindow, setShowContactFormWindow } = useAppContext()

  // const [showBothButtons, setShowBothButtons] = useState(false)

  // const onContactUsBtnClick = ctaTitle => {
  //   // document.getElementById("heartElement")?.click()
  //   setShowContactFormWindow(true)
  //   // navigate("/contact-us")
  //   gtag("event", ctaTitle, {
  //     event_category: "contact-us",
  //     event_label: "Contact Form",
  //   })
  // }

  const handleNavigatetoAiProducts = () => {
    const ele = document.getElementById("our-ai-products-section")
    if (ele) {
      ele.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <div className="section solutions-menu-section" id="solutions-menu-section">
      <div className="background-fade" />
      <h2 className="homepage-section-title">
        Top AI Solutions Proven to Boost ROI for Enterprises
      </h2>
      <div className="menu-container">
        {data?.map((cardData, index) => (
          <MenuCard cardData={cardData} index={index} key={index} />
        ))}
      </div>

      {data?.cta_title && (
        <div className="cta-container">
          <h3 className="cta-title">{data?.cta_title}</h3>
          <ConnectWithUsBtns
            // initialTitle={"Let's Connect"}
            showBothButtons={showBothButtons}
            setShowBothButtons={setShowBothButtons}
            // setShowChatWindow={setShowChatWindow}
            // onContactUsBtnClick={onContactUsBtnClick}
          />
        </div>
      )}

      <div
        className="ai-products-cta"
        onClick={() => handleNavigatetoAiProducts()}
      >
        Don't see a solution that fit your needs? Check out{" "}
        <b>Our AI Products</b>
      </div>
    </div>
  )
}

export default SolutionsMenu
